<template>
  <div class="mail_box">
    <section class="no_padding">
      <template v-if="messages.length > 0" >
        <h2>
          <v-icon color="mail_box_headline_font">mdi-message-question-outline</v-icon>
          {{ support.name }}メッセージ
        </h2>
        <div class="chat_log_box">
          <div v-for="(message, index) in messages" :key="index" :class="`message ${message.sender === 'support' ? 'message_is_support' : 'message_is_user'}`">
            <div v-if="index === unreadBorderIndex" class="unread-divider mb-4">
              <hr />
              <div class="unread-start-text">
                ここから未読メッセージ
              </div>
            </div>
            <div class="d-flex align-start">
              <v-icon v-if="message.sender === 'support'" color="mail_box_headline_font mr-1">mdi-face-agent</v-icon>
              <div class="message_card mb-1">
                <p class="message_body mb-0" v-html="convertNewlines(message.body)"></p>
              </div>
            </div>
            <div v-if="message.image_token" class="message_image mb-1">
              <img :src="messageImage(message.image_token)"/>
            </div>
            <p class="message_sent_at mb-0">{{ message.sent_at }}</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="support_input_title text_center">
          <div class="header_underline">お問い合わせ内容を送信</div>
        </div>
      </template>
      <div class="message_input mb-10">
        <h3 v-if="messages.length > 0">お問い合わせ内容を送信</h3>
        <ValidationObserver ref="form">
          <ValidationProvider name="メッセージ" rules="required|max:1000" v-slot="{ errors }">
            <v-textarea
              v-model="body"
              placeholder="こちらをタッチしてメッセージを入力してください"
              rows="8"
              hide-details = "auto"
            ></v-textarea>
            <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            <span class="valid_error" v-if="errors.image">{{ errors.image }}</span>
          </ValidationProvider>
        </ValidationObserver>
        <div v-if="previewUrl" class="mt-2 preview">
          <img :src="previewUrl" alt="プレビュー"/>
        </div>
        <div class="d-flex mt-3">
          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            ref="fileInput"
            style="display: none"
            @change="handleFileChange"
          />
          <template v-if="!file">
            <v-btn class="img_btn mr-2" rounded @click="openFilePicker">画像を添付する</v-btn>
          </template>
          <template v-else>
            <v-btn class="img_btn remove_btn mr-2" rounded  @click="removeImage">画像を削除する</v-btn>
          </template>
          <v-btn class="send_btn" rounded @click="goToConfirm">送信確認へ</v-btn>
        </div>
      </div>
      <p class="text-center">
        <router-link :to="{ name: 'SupportBox' }" class="arrow link_main--text">サポートBOX一覧に戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
import { IMAGE_URL } from '@/common/config'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, max } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_}を入力してください'
})

extend('max', {
  ...max,
  message: '{_field_}は{length}文字以内で入力してください'
})

export default {
  name: 'SupportBoxDetail',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    const from = (this.$route.params && this.$route.params.from) || {}
    return {
      body: from.body || '',
      previewUrl: from.previewUrl || null,
      file: from.image || null,
      errors: {
        image: null
      },
      support: {},
      messages: []
    }
  },
  methods: {
    getDetail () {
      const pathParts = this.$route.path.split('/')
      const id = pathParts[2] || null
      if (id) {
        this.$store
          .dispatch('getSupportBoxDetail', id)
          .then((data) => {
            this.support = data.support
            this.messages = data.messages
          }).catch(err => {
            console.error(err)
          })
      }
    },
    convertNewlines (text) {
      return text.replace(/\n/g, '<br>')
    },
    messageImage (token) {
      return IMAGE_URL + token
    },
    openFilePicker () {
      this.$refs.fileInput.click()
    },
    handleFileChange (event) {
      const file = event.target.files[0]
      this.errors.image = null // 毎回初期化

      if (!file) return

      const allowedTypes = ['image/jpeg', 'image/png']
      const allowedExtensions = ['.jpg', '.jpeg', '.png']

      const fileType = file.type
      const fileName = file.name.toLowerCase()
      const fileExtension = fileName.slice(fileName.lastIndexOf('.'))

      if (!allowedTypes.includes(fileType)) {
        this.errors.image = 'JPEGまたはPNG形式の画像のみ選択できます。'
        return
      }

      if (!allowedExtensions.includes(fileExtension)) {
        this.errors.image = '拡張子が .jpg / .jpeg / .png の画像のみ選択できます。'
        return
      }

      // OK
      this.file = file
      this.previewUrl = URL.createObjectURL(file)
    },
    removeImage () {
      this.file = null
      this.previewUrl = null
      this.$refs.fileInput.value = ''
    },
    goToConfirm () {
      if (!this.body.trim()) {
        alert('メッセージを入力してください')
        return
      }
      const pathParts = this.$route.path.split('/')
      const id = pathParts[2] || null

      if (id) {
        this.$router.push({
          name: 'SupportMessageConfirm',
          params: {
            id: id,
            from: {
              support_id: this.support.id,
              support_name: this.support.name,
              body: this.body,
              image: this.file || null,
              previewUrl: this.previewUrl || null
            }
          }
        }).catch(err => {
          if (!err.message.includes('Redirected')) {
            console.error(err)
          }
        })
      }
    }
  },
  computed: {
    unreadBorderIndex () {
      const index = this.messages.map(msg => msg.is_read).lastIndexOf(0)
      return index !== -1 ? index : null
    }
  },
  created () {
    this.getDetail()
  }
}
</script>
